module.exports = __webpack_public_path__ + "img/calendar-icon-black.8cc77582.svg";